import { JbCartItem } from '@jbhi-fi/apis/src/shopify/types/JbCart';

/**
 * Returns a new cart items array with the provided SKU moved to the chosen edge.
 * Useful for pinning service lines above/below product lines without mutating the original array.
 */

export const reOrderCartItems = (
  cartItems: Array<JbCartItem> = [],
  targetSku = '',
  position: 'start' | 'end'
): Array<JbCartItem> => {
  if (!targetSku) return cartItems;

  const matchedItems: Array<JbCartItem> = [];
  const remainingItems: Array<JbCartItem> = [];

  cartItems.forEach(item => {
    if (item.sku && item.sku === targetSku) {
      matchedItems.push(item);
      return;
    }

    remainingItems.push(item);
  });

  if (!matchedItems.length) return cartItems;

  switch (position) {
    case 'start':
      return [...matchedItems, ...remainingItems];
    case 'end':
      return [...remainingItems, ...matchedItems];
    default:
      return cartItems;
  }
};
